var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-3",attrs:{"fluid":"","tag":"section"}},[_c('v-row',[_c('v-col',[_c('h2',{staticClass:"text-center"},[_vm._v("Интеграции")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }